import { computed, Injectable, signal } from "@angular/core";

@Injectable({ providedIn: "root" })
export class NoRoleStore {
    readonly _noRole = signal(false);
    readonly noRole = computed(() => this._noRole());

    setNoRole(value: boolean) {
        this._noRole.set(value);
    }
}
